import createReducers from './createReducers';
import {applyMiddleware, compose, legacy_createStore} from "redux";

const composeEnhancers =
  ((import.meta.env.REACT_APP_ENV !== 'production') &&
    typeof window !== 'undefined' &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
  compose;

const configureStore = (sagaMiddleware) => {
    return legacy_createStore(
        createReducers(),
        composeEnhancers(applyMiddleware(sagaMiddleware))
    );
}
export default configureStore